module.exports = __webpack_public_path__ + "static/media/Lynkgrid.338f5e32.png";